import { useEffect } from 'react';

import { useContentFilterStore, useSharedFilterStore, useTaxonomyFilterStore } from '../../../store/content-filter';
import { NexoyaPortfolioParentContentsSortField } from '../../../types';

type ReconcileArgs = { legacyLabelsEnabled: boolean };

/**
 * Hidden portfolio labels have no submenu, chip or column header left to clear them with, so a stored
 * selection or label-name sort is dropped here. Clearing the store, not just the main query, keeps
 * every other `buildPortfolioContentFilterVariables` caller (mutation refetches) on the same cache key.
 */
export function useReconcileLegacyLabelsFilter({ legacyLabelsEnabled }: ReconcileArgs): void {
  const hasLegacySelection = useTaxonomyFilterStore((s) => s.labelsFilter.length > 0 || s.includeNoLabel);
  const sortsByLabelName = useSharedFilterStore(
    (s) => s.sortField === NexoyaPortfolioParentContentsSortField.LabelName,
  );

  useEffect(() => {
    if (legacyLabelsEnabled) return;
    if (hasLegacySelection) useContentFilterStore.getState().resetAllFilters('labelsFilter');
    if (sortsByLabelName) useSharedFilterStore.setState({ sortField: undefined, sortOrder: undefined });
  }, [legacyLabelsEnabled, hasLegacySelection, sortsByLabelName]);
}
